import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DateFormatPipe, EddyAutoComplete, FuncaoService, GlobalService, Login, RplItem, Unidade, UnidadeRecurso, UnidadeRecursoSubstituto, Usuario, UsuarioService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UnidadeRecursoSubstitutoService } from '../service/unidade-recurso-substituto.service';
import { UnidadeRecursoService } from '../service/unidade-recurso.service';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-unidade-recurso-substituto-dlg',
  templateUrl: './unidade-recurso-substituto-dlg.component.html'
})
export class UnidadeRecursoSubstitutoDlgComponent implements OnInit, OnChanges {

  @Input() unidadeRecurso: UnidadeRecurso;
  @Input() login: Login = new Login();

  public listaUnidadeRecursoSubstituto: Array<UnidadeRecursoSubstituto> = new Array<UnidadeRecursoSubstituto>();
  protected unsubscribe: Subject<void> = new Subject();
  // public rplItemFichaDespesa: RplItemFichaDespesa;
  public usuarioAutoComplete: EddyAutoComplete<Usuario>;
  public edicao: boolean = false;
  public itemAnterior: UnidadeRecursoSubstituto;
  public itemAtual: UnidadeRecursoSubstituto;
  public ptBR: any;

  @Input() entidade: Unidade;

  public imaskQtd = {
    mask: Number,
    scale: 8,
    signed: false
  };

  constructor(
    protected injector: Injector,
    protected usuarioService: UsuarioService,
    protected unidadeRecursoService: UnidadeRecursoService,
    protected unidadeRecursoSubstitutoService: UnidadeRecursoSubstitutoService,
    protected confirmationService: ConfirmationService,
    public globalService: GlobalService,
    public funcaoService: FuncaoService,
  ) {
    this.ptBR = new GlobalService().obterDataBR();
  }

  ngOnInit(): void {
    this.carregarAutoCompletes();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (this.entidade?.recursos?.length) {
      this.carregarAutoCompletes();
    }
    if (this.unidadeRecurso?.id && !this.unidadeRecurso?.unidade_recurso_substitutos) {
      await this.unidadeRecursoSubstitutoService.extendido(1, -1, { 'unidade_recurso.id': this.unidadeRecurso?.id, relations: 'usuario' }).subscribe(a => {
        this.listaUnidadeRecursoSubstituto = a ? a.content : []
      });
    } else {
      this.listaUnidadeRecursoSubstituto = this.unidadeRecurso?.unidade_recurso_substitutos ? this.unidadeRecurso.unidade_recurso_substitutos : [];
    }
  }

  public adicionarItem() {
    if (this.edicao) return;
    this.adicionar();
  }

  private adicionar() {
    if (this.edicao) return;
    if (this.listaUnidadeRecursoSubstituto && this.listaUnidadeRecursoSubstituto.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de incluir outro item');
      return;
    }

    this.itemAnterior = undefined;
    this.itemAtual = new UnidadeRecursoSubstituto();
    this.itemAtual.editavel = true;
    this.itemAtual.unidade_recurso = { id: this.unidadeRecurso.id }
    this.edicao = true;

    this.listaUnidadeRecursoSubstituto.unshift(this.itemAtual);
  }

  onModelChange(value: string) {
    // if (this.data_limite.length >= 10) {
    //   if ((this.data_limite.substring(0, 2) <= this.data_inicio.substring(0, 2) && this.data_limite.substring(3, 5) <= this.data_inicio.substring(3, 5) && this.data_limite.substring(6, 10) <= this.data_inicio.substring(6, 10))
    //     || (this.data_limite.substring(0, 2) > this.data_inicio.substring(0, 2) && (this.data_limite.substring(3, 5) < this.data_inicio.substring(3, 5)) || (this.data_limite.substring(6, 10) < this.data_inicio.substring(6, 10)))) {
    //     toastr.warning('A data limite é menor que a data inicial.', 'Atenção!')
    //   }
    // }
  }


  public async salvar(item: UnidadeRecursoSubstituto = new UnidadeRecursoSubstituto()) {
    if (!this.edicao) return;
    try {
      if (!item.usuario) {
        throw new Error('Informe o Responsável!');
      }

      if (!item.data_inicio) {
        throw new Error('Informe o início da vigência!');
      }

      if (!item.data_termino) {
        throw new Error('Informe o final da vigência!');
      }

      if (item.data_termino < item.data_inicio) {
        throw new Error('A data do final da vigência não pode ser menor que a inicial!');
      }
      this.itemAtual.editavel = false;
      this.itemAtual = undefined;
      this.itemAnterior = undefined;
      this.edicao = false;
      this.ordenarItens();
    } catch (e) {
      this.funcaoService.acaoErro(e)
      throw e;
    }
  }

  public fechar() {
    if (this.edicao) return;
    $(`#unidadeRecursoSubstituto`).modal('hide');
  }

  private carregarAutoCompletes() {
    this.usuarioAutoComplete = new EddyAutoComplete(null, this.usuarioService,
      'id', ['cpf', 'nome', 'sobrenome'], { orgao_id: this.login.orgao.id, orderBy: 'nome', ativo: true, 'id$ne': this.unidadeRecurso?.usuario?.id }, { number: ['id'], text: ['email', 'nome', 'sobrenome', 'cpf'] }, async () => {
        if (this.listaUnidadeRecursoSubstituto.find((item) => item.usuario && item?.usuario?.id === this.itemAtual?.usuario?.id && this.itemAtual['editavel'] && !item['editavel'])) {
          this.itemAtual.usuario = null;
          this.usuarioAutoComplete.id = null;
          toastr.error('Usuario já adicionado!', 'Erro');
          return;
        }
      }, null, (usuario) => {
        if (this.listaUnidadeRecursoSubstituto?.find((item) => item?.usuario && item?.usuario?.id === usuario?.id && this.itemAtual['editavel'] && !item['editavel'])) {
          // toastr.error('Usuario já adicionado!', 'Erro');
          return '';
        } else {
          return usuario.cpf + ' - ' + usuario.nome + ' ' + usuario.sobrenome
        }
      }
    );
  }

  public remover(item: UnidadeRecursoSubstituto, index: number) {
    if (this.edicao) return;
    if (item.id) {
      this.confirmationService.confirm({
        message: `Deseja realmente remover o responsável substituto: ${item.usuario.nome} ${item.usuario.sobrenome}?`,
        key: 'rifd',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.unidadeRecursoSubstitutoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.listaUnidadeRecursoSubstituto.splice(index, 1);
              this.atualizarOrdem();
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.listaUnidadeRecursoSubstituto.splice(index, 1);
      this.atualizarOrdem();
    }
  }

  public editar(item: UnidadeRecursoSubstituto = new UnidadeRecursoSubstituto()) {
    if (this.edicao) return;
    if (this.listaUnidadeRecursoSubstituto && this.listaUnidadeRecursoSubstituto.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }
    this.itemAnterior = Object.assign({}, item);
    this.itemAtual = item;
    this.itemAtual.data_inicio = new DateFormatPipe().transform(item.data_inicio, []);
    this.itemAtual.data_termino = new DateFormatPipe().transform(item.data_termino, []);
    this.itemAtual.editavel = true;
    this.edicao = true;
  }

  public cancelar(item: RplItem, index: number) {
    if (!this.edicao) return;
    this.itemAtual = Object.assign({}, this.itemAnterior);

    if (!this.itemAtual) {
      this.listaUnidadeRecursoSubstituto.splice(index, 1);
    } else if (!item.id && !this.itemAtual?.usuario?.id) {
      this.listaUnidadeRecursoSubstituto.splice(index, 1);
    } else {
      item.editavel = false;
    }
    this.itemAtual = undefined;
    this.itemAnterior = undefined;
    this.edicao = false;
  }

  public ordenarItens() {
    if (!this.edicao) return;

    this.listaUnidadeRecursoSubstituto.sort((a, b) => {
      const timeA = new Date(a.data_termino).getTime();
      const timeB = new Date(b.data_termino).getTime();
      return timeB - timeA;
    });
  }

  public atualizarOrdem() {
    if (!this.edicao) return;
    this.ordenarItens();
  }

  public async confirmar() {
    if (this.edicao) return;
    if (this.listaUnidadeRecursoSubstituto.length <= 0 && this.unidadeRecurso.id) {
      toastr.info('Informe o responsável substituto!');
      return;
    }

    this.unidadeRecurso.unidade_recurso_substitutos = this.listaUnidadeRecursoSubstituto
    $('#unidadeRecursoSubstituto').modal('hide');
  }
}
